import React, { useRef } from 'react';
import DonutProgress from '@/components/Partners/DonutProgress';
import './index.less';

const SupplierStats = () => {
  const statsRef = useRef<HTMLDivElement>(null);

  const circleData = [
    {
      key: 'creator-accounts',
      quantity: '85k+',
      title: 'Creator Accounts',
      desc: ['Over 80,000 active Creators'],
    },
    {
      key: 'monthly-visitors',
      quantity: '100k+',
      title: 'Monthly Visitors',
      desc: ['Connect with new users daily'],
    },
    {
      key: 'transactions',
      quantity: '50k+',
      title: 'Transactions',
      desc: ['Millions of dollars in GMV', 'processed monthly'],
    },
  ];

  const statistics = [
    'A Creator makes a purchase on Pietra every 4 minutes',
    'Order values processed on Pietra $500-$100,000k+',
    'Pietra Creators span 6 continents across the globe',
  ];

  return (
    <div className="stats-container">
      <div className="stats-graphs" ref={statsRef}>
        {circleData.map((d) => (
          <DonutProgress
            key={d.key}
            title={d.title}
            desc={d.desc}
            quantity={d.quantity}
            shouldAnimate={true}
            className="donut-progress"
          />
        ))}
      </div>
      <div className="stats-descriptions">
        {statistics.map((d) => (
          <span className="stat" key={d}>
            {d}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SupplierStats;
